import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { projectSummaryEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-project-summary/entrypoint.tsx';

export const projectSummaryPageEntryPoint = createPageEntryPoint({
	main: projectSummaryEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
